export default function allObjectPropertiesEmpty(object) {
  let allEmpty = true;
  Object.keys(object).forEach((key) => {
    if (object[key]) {
      allEmpty = false;
    }
  });
  return allEmpty;
}
